import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["carbohydrate-during-a-marathon"]!;

export function Body() {
  return (
    <>
      <p>
        Gels, sports drinks, nothing at all? Carbohydrate during a race is one of the most
        practical questions in endurance running. A systematic review of 61 studies shows that
        the answer depends a lot on how long you are out there.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Researchers reviewed randomised studies that compared carbohydrate with a placebo during
        all-out or endurance exercise. In total, 61 studies with 679 participants were included.
      </p>

      <h2>What they found</h2>
      <p>
        In 82 percent of the studies, carbohydrate improved performance compared with placebo.
        The longer the exercise lasted, the larger the benefit tended to be.
      </p>
      <p>
        For efforts of about an hour, the benefit seemed to come mostly from carbohydrate in the
        mouth signalling to the brain. Even rinsing the mouth helped, so the amount hardly
        mattered.
      </p>
      <p>
        For efforts longer than two hours, when the body's own glycogen stores run low, the amount
        mattered. The best results came with high intakes of around 90 grams an hour or more,
        using a mix of glucose and fructose, which the gut can absorb faster than glucose alone.
      </p>

      <h2>What it means for you</h2>
      <p>
        In a 10K or a fast half marathon, a sip of sports drink or a gel before the start is
        usually enough. In a marathon, regular carbohydrate makes a real difference. Many runners
        aim for 60 to 90 grams an hour, and those who tolerate it can go higher.
      </p>
      <p>
        The gut can be trained. Practise your race-day intake on long runs, with the same
        products, and build up gradually. Never try something new on race day.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        Most of the studies were done in laboratory conditions, often on bikes. How much you
        tolerate while running is individual, and the review recommends tailoring intake to each
        athlete.
      </p>

      <h2>How we use it</h2>
      <p>
        Your long runs in PX7 Training are the natural place to practise race fuelling. Use the
        final long runs before your race to rehearse the plan you will use on the day.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Stellingwerff & Cox (2014), Systematic review: carbohydrate supplementation on exercise
          performance or capacity of varying durations.{" "}
          <a href="https://doi.org/10.1139/apnm-2014-0027">Applied Physiology, Nutrition, and Metabolism</a>.
        </li>
      </ul>
    </>
  );
}
